// Copy for the Help tab. See HelpScreen.tsx.
//
// Being stuck has one tab. The master had a Chat tab and articles on Home,
// which asks somebody who is stuck to work out whether their problem is a
// talking problem or a reading problem before they can go anywhere. All three
// ways are here, and talking is first: a person who opens Help usually wants a
// person.
export const HELP = {
  talk: 'Talk to us',

  /**
   * Live, and therefore dated. Webinars sit above the articles because they
   * expire: an article is there whenever you look, and a session you have
   * missed is worth nothing, so the one with a deadline goes first.
   */
  searchWebinars: 'Search webinars',
  searchArticles: 'Search help articles',
  noMatches: 'Nothing matches that.',
  webinarsTitle: 'Webinars',
  webinars: [
    {
      id: 'funding-basics',
      title: 'Paying for care: the basics',
      when: 'Tue 26 May, 6pm',
      summary:
        'What the council covers, what you cover, and where the line is.',
    },
    {
      id: 'attendance-allowance',
      title: 'Claiming Attendance Allowance',
      when: 'Thu 4 Jun, 1pm',
      summary: 'Walking the form through, with time for questions at the end.',
    },
  ],

  /** Talk to us opens Intercom's messenger. A stand-in for it, not ours. */
  chat: {
    title: 'KareHero',
    replies: 'We usually reply in a few minutes',
    greeting: 'Hi, how can we help?',
    placeholder: 'Write a message',
    close: 'Close',
    send: 'Send',
  },

  articlesTitle: 'Help articles',
  articles: [
    {
      id: 'funding',
      title: 'Understanding care funding options',
      summary: 'A plain-English guide to who pays for care and how.',
    },
    {
      id: 'attendance-allowance',
      title: 'What Attendance Allowance is worth',
      summary: 'The two rates, who qualifies, and what it does not affect.',
    },
    {
      id: 'attorney',
      title: 'Setting up power of attorney',
      summary: 'What it covers, what it costs, and when to do it.',
    },
  ],
};
